import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { openPopup } from "../reducers/popup";
import { POPUP_NAME, STATUS_CAMPAIGN } from "../utilities/constants";
import { getFullDateString } from "../services/popup";

const InfoRule = () => {
  const dispatch = useDispatch();
  const statusCampaign = useSelector((state) => state?.user?.statusCampaign);
  const voteOfUser = useSelector((state) => state?.user?.voteOfUser || 0);
  const profile = useSelector((state) => state?.user?.profile || {});
  const campaignStartAt = useSelector((state) => state?.user?.campaignStartAt) || process.env.REACT_APP_CAMPAIGN_START_AT;
  const campaignEndAt = useSelector((state) => state?.user?.campaignEndAt) || process.env.REACT_APP_CAMPAIGN_END_AT;




  const openPopupInfoRule = () => {
    if (statusCampaign === STATUS_CAMPAIGN.NOT_STARTED) {
      dispatch(openPopup({ name: POPUP_NAME.SHOW_NOT_STARTED }));
      return;
    }
    dispatch(openPopup({ name: POPUP_NAME.INFO_RULE }));
  };

  const handleRegisterVip = () => {
    window.open("https://vieon.vn/mua-goi/", "_blank");
  };

  const onClickUser = () => {
    dispatch(
      openPopup({
        name: !!profile?.id ? POPUP_NAME.LOGOUT : POPUP_NAME.LOGIN,
      })
    );
  };

  return (
    <div className="mb-[7vw]">
      <div className={`form-intro-bg w-[90vw] ${profile?.id ? "h-[45vw]" : "h-[58vw]"}  my-[-3.7vw] px-[5vw] flex flex-col justify-center text-white text-[3.5vw] text-center mx-auto`}>
        {profile?.id && <div>Bình chọn cho Anh Trai yêu thích</div>
        }
        {!profile?.id ? (
          <div>
            <span
              onClick={onClickUser}
              className="cursor-pointer text-[#0ee2ff]"
            >
              Đăng nhập {" "}
            </span>
            mỗi ngày để bình chọn cho<br/> các Anh Trai mà bạn yêu thích
          </div>
        ) : (
          <div className="leading-none">
            Bạn còn
            <span> {voteOfUser} </span>
            lượt bình chọn hôm nay
          </div>
        )}
        <div className="mb-[3vw]">
          {!profile?.id ? <div>Tài khoản miễn phí: 1 lượt/ngày</div> : ""}



          {!profile?.id && <div>

            <span
              onClick={handleRegisterVip}
              className="cursor-pointer lg:px-2 text-[#0ee2ff]"
            >
              Tài khoản VIP:{" "}
            </span>
            5 lượt/ngày</div>
          }
          {profile?.id && profile?.is_premium === 0 ? (
            <>
              <span
                onClick={handleRegisterVip}
                className="px-1 cursor-pointer lg:px-2 text-[#0ee2ff]"
              >
                Đăng ký VIP
              </span>
              để có 5 lượt mỗi ngày.
            </>
          ) : (
            ""
          )}

        </div>
        <div>Thời gian bình chọn</div>
        <div>
          Từ  {getFullDateString(campaignStartAt)} đến
        </div>
        <div>
          {getFullDateString(campaignEndAt)}
        </div>
        <div
          onClick={openPopupInfoRule}
          className="text-[#0ee2ff] cursor-pointer"
        >
          Thể lệ chương trình
        </div>
      </div>
    </div>
  );
};

export default InfoRule;
